import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Marked } from 'marked';

const parser = new Marked({
  gfm: true,
  breaks: true,
  renderer: {
    // Replies support Markdown, not embedded HTML or remote image loading.
    html: () => '',
    image: () => '',
  },
});

@Component({
  selector: 'app-markdown',
  template: '<div class="app-markdown" [innerHTML]="html()"></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: block; min-width: 0;' },
})
export class MarkdownComponent {
  readonly content = input.required<string>();
  // Keep a plain string: Angular sanitizes innerHTML, including unsafe link URLs.
  protected readonly html = computed(() => parser.parse(this.content(), { async: false }));
}
